export const toggleWatchlist = async ({
  isOpen,
}: {
  isOpen: boolean;
}): Promise<undefined> => {
  const endpoint = "/api/watchlist";
  const res = await fetch(`${window.location.origin}${endpoint}`, {
    method: "POST",
    body: JSON.stringify({
      isWatchlistOpen: !isOpen,
    }),
  });

  if (!res.ok) throw new Error(`API failed (${endpoint})`);
};
